module.exports = __webpack_public_path__ + "f41db30941a7d8fd573e263e6be7208c.png";